export default {"src":"/_next/static/media/nutmilk.558daab4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};